
const MagazineColData = [
    {
        key: "1",
        label: <span className='text-[14px] font-poppins-regular'>When will you arrive to set-up?</span>,
        children: <p className="pl-[10px] sm:pl-[40px] text-[14px] font-poppins-regular">
          
          The event specialist will arrive <strong>1 Hour </strong>before the event to set-up. Upon request, 
          we are able to arrive extra early to ensure 
          the photo booth is set-up at a specific time​.
           </p>,
      },
      {
        key: "2",
        label: <span className='text-[14px] font-poppins-regular'>How much space is needed?</span>,
        children: <p className="pl-[10px] sm:pl-[40px] text-[14px] font-poppins-regular"> Typically <strong>Photo Booth requires 8x8ft.</strong> It can be squeezed in to a small footprint, but please discuss with us first.</p>,
      },
      {
        key: "3",
        label: <span className='text-[14px] font-poppins-regular'>Is an operator included?</span>,
        children: <p className="pl-[10px] sm:pl-[40px] text-[14px] font-poppins-regular"> <strong>Yes Photo Booth includes an operator</strong> who will set everything up ensure it’s running smoothly, and pack it up at the end of the event.</p>,
      },
      {
        key: "4",
        label: <span className='text-[14px] font-poppins-regular'>How do guests receive their photos?</span>,
        children: <p className="pl-[10px] sm:pl-[40px] text-[14px] font-poppins-regular"> 
        Click the "Book Now" button below and choose a package and time. Once you confirm you booking, 
        you will receive an invoice to pay your deposit and secure your rental. 
        <strong>Afterwards, we will send you a questionnaire to give us additional event info. </strong>
        We promise to make this smooth and easy!
        
        </p>,
        style: { borderWidth: '0px 0px 1px 0px', borderStyle: 'solid', borderColor: '#000', },
      },
];
export default MagazineColData
